module.exports = __webpack_public_path__ + "img/astlibe.aae196cd.jpg";